import Head from 'next/head'
import styles from '../../styles/index.module.css'
import Script from 'next/script'

export default function Home() {

  return (
    <>
      <Head>
        <title>Consumer Service Warranty | StringsSG</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="These terms apply to consumer clients for service taken from StringsSG"/>
        <meta name="keywords" content="We help you in HDB or Condo rental and purchase, health Investment and Insurance plan, food catering,
	         domestic helper, handyman services, aircon servicing, beauty and massage, interior designing, fitness trainer, 
	         wedding, birthday and other event planning"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com/terms/consumer-warranty" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={`Consumer Service Warranty | StringsSG`}/>
        <meta property="og:description" content="These terms apply to consumer clients for service taken from StringsSG" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/terms/consumer-warranty"/>
        <meta name="twitter:title" content={`Consumer Service Warranty | StringsSG`}/> 
        <meta name="twitter:description" content="These terms apply to consumer clients for service taken from StringsSG"/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/terms/consumer-warranty"/>
        </Head>
            <div className="max-w-4xl mx-auto py-4"> 
                <div id="refund-policy" className='text-gray-500 p-4 space-y-6 py-8 leading-7 text-sm'>
                    <h1 className='text-xl uppercase'>Warranty Claims by Consumer Clients to Service Providers</h1>
                    <div className='space-y-2' id="part-time-helper">
                        <h3 className='font-bold text-lg text-gray-400'>1. Warranty on Part-Time Helper Cleaner Service:</h3>
                        <p>
                            For services in the domestic services segment, there is no warranty period provided. However, we encourage consumer clients to report any issues they 
                            encounter with the service during the service itself either to the service staff, the platform chat or StringsSG chat support. 
                            In addition, consumer clients have the option to express their feedback through a rating and review on the service 
                            partners&apos;s profile. Your feedback helps us maintain the highest quality of service.
                        </p>
                    </div>
                    <div className='space-y-2' id="handyman-service">
                        <h3 className='font-bold text-lg text-gray-400'>2. Warranty On Handyman Services:</h3>
                        <p>
                            For handyman services, a 30-day workmanship warranty is provided for all services rendered. This means that if any issues 
                            arise within 30 days after the service is provided, if related to or caused by the last service, it will addressed and rectified those issues at no additional cost to the consumer client.
                        </p>
                        <p>
                            If the service includes part replacement or new system installation, please note that the manufacturer&apos;s warranty will apply to the installed items. 
                            The manufacturer&apos;s warranty typically covers defects or issues related to the specific parts or systems installed, and the consumer client should refer to the manufacturer&apos;s terms for details.
                        </p>
                    </div>
                    <div className='space-y-2' id="aircon-service">
                        <h3 className='font-bold text-lg text-gray-400'>2. Warranty On Aircon Services:</h3>
                        <p>
                            For aircon services, all services comes with a 30-day workmanship warranty. This warranty ensures that any issues 
                            arising within 30 days after the service, if related to or caused by the last service will be addressed and resolved by the service provider, with no 
                            additional charges to the consumer client. The warranty doesn&apos;t cover any pre-existing conditions. Air conditioning systems are constructed with 
                            durable materials designed to withstand any general cleaning service or chemical wash. Any damaged caused
                            to ac units during a service is not covered if there is preexisting significant wear and tear due to aging or inadequate maintenance.
                        </p>
                        <p>
                            However if the service provided is either chemical wash, chemical overhaul or chemical drainage flushing, the warranty on the workmanship is 60-days.
                        </p>
                        <p>
                            For refrigerant gas refill, the warranty on the workmanship is 90-days.
                        </p>
                        <p>
                            If the service includes part replacement or new system installation, please note that the manufacturer&apos;s warranty will apply to the installed items. 
                            The manufacturer&apos;s warranty typically covers defects or issues related to the specific parts or systems installed, and the consumer client should refer to the manufacturer&apos;s terms for details.
                        </p>
                    </div>
                </div>
            </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
